import { isMobile } from "../../js/global-scripts";

const mapOptions = {
    maxZoom: 21,
    minZoom: 2,
    duration: 300,
    typeScheme: 'yandex#map',
    typeHybrid: 'yandex#hybrid'
}

try {
    ymaps.ready(init);
} catch (err) { }

function init() {
    const mapContainer = document.querySelector('#hybrid-map')

    if (mapContainer) {
        const wrapper = mapContainer.closest('.hybrid-map-container')
        const controlsContainer = createControlsContainer(wrapper)
        const controlsTop = createControlsTop(wrapper)

        const isLand = mapContainer.classList.contains('is-land')
        const typeMap = isLand ? 'land' : 'villages'
        const myMap = new ymaps.Map(mapContainer, {
            center: [55.755819, 37.617644],
            zoom: 9,
            controls: [],
            margin: [60, 20, 20, 20],
        }, {
            maxZoom: mapOptions.maxZoom,
            minZoom: mapOptions.minZoom,
            suppressMapOpenBlock: true,
            autoFitToViewport: 'always'
        })
        let geoCollection = []

        myMap.behaviors.disable('scrollZoom')
        if (isMobile.any()) {
            myMap.behaviors.disable('drag')
        }

        initZoom(myMap, controlsContainer)
        initMapType(myMap, controlsTop)

        if (isLand) {
            /**
             * Button favorite
             */
            const buttonToggleFavorite = createButton('favorite')
            controlsTop.appendChild(buttonToggleFavorite)
            const textToggle = {
                isAll: true,
                all: 'Показать все',
                favorite: 'Показать только избранные',
            }

            buttonToggleFavorite.addEventListener('click', (e) => {
                const buttonEl = wrapper.querySelector('.btn-map-favorite-toggle')
                if (textToggle.isAll) {//show favorite
                    buttonEl.textContent = textToggle.all
                    textToggle.isAll = false
                } else {//show all
                    buttonEl.textContent = textToggle.favorite
                    textToggle.isAll = true
                }

                renderCollection()
            })

            /**
             * Change Favorites
             */
            PubSub.subscribe(CHANNEL_NAMES.landChangeFavorites, ({ id, operation, ...data }) => {
                if (!geoCollection.length) return

                const isFavorite = operation === 'add'

                //upd map collection
                geoCollection.map(obj => {
                    if (obj.options.get('id') === id) {
                        obj.options.set('isFavorite', isFavorite)

                        switch (obj.geometry.getType()) {
                            case 'Point':
                                const icons = getIcons(obj.options.get('theme'), isFavorite)
                                obj.options.set({
                                    iconImageHref: icons.marker,
                                })
                                break
                            case 'Polygon':
                                obj.options.set(getStylesPolygon(isFavorite))
                                break
                        }
                    }
                })

                //render updated collection
                renderCollection()

            })

            function renderCollection() {
                myMap.geoObjects.removeAll()
                if (textToggle.isAll) {
                    ymaps.geoQuery(geoCollection).addToMap(myMap)
                    $(document).find('.area-block__list .area-card').show();
                } else {
                    ymaps.geoQuery(geoCollection).search(`options.isFavorite = true`).addToMap(myMap)

                    var objcts = ymaps.geoQuery(geoCollection)._objects;

                    for (let index = 0; index < objcts.length; index++) {
                        const objct = objcts[index];
                        if (objct.options.get('isFavorite')) {
                            $(document).find('.area-block__list .area-card[data-area-id=' + objct.options.get('id') + ']').show();
                        } else {
                            $(document).find('.area-block__list .area-card[data-area-id=' + objct.options.get('id') + ']').hide();
                        }

                    }


                }
            }
        }

        /**
         * Render objects
         */
        PubSub.publish(CHANNEL_NAMES.hybridMapData.get, { typeMap })

        PubSub.subscribe(CHANNEL_NAMES.hybridMapData.getSuccess, data => {
            // Очистка карты
            myMap.geoObjects.removeAll()
            geoCollection = []

            if (!Array.isArray(data)) return

            const favoriteLandsArr = getCookie('FAVORITE_LANDS') ? getCookie('FAVORITE_LANDS')?.split(',') : []

            // наполняем коллекцию
            data.forEach(item => {
                const objectID = item.id

                const isFavorite = favoriteLandsArr.indexOf(objectID) !== -1
                const icons = getIcons(item.type, isFavorite)

                const coordinatesMarker = item.objects.placemark
                if (Array.isArray(coordinatesMarker) && coordinatesMarker.length) {
                    let placeMark = new ymaps.Placemark(coordinatesMarker, {
                        // hintContent: objectID
                        balloonContent: `
                            <div class='hybrid-map-balloon theme-${item.type}'>
                                <div class="hybrid-map-balloon__ic"><img src=${icons.balloon} alt="icon"></div>
                                <h5 class="hybrid-map-balloon__title">${item.name}</h5>
                            </div>
                        `
                    }, {
                        id: objectID,
                        theme: item.type,
                        isFavorite: isFavorite,
                        balloonPanelMaxMapArea: 0,
                        balloonCloseButton: false,
                        balloonOffset: [0, -67],
                        openBalloonOnClick: !isLand,
                        hideIconOnBalloonOpen: false,
                        iconLayout: 'default#image',
                        iconImageHref: icons.marker,
                        iconImageSize: [49, 63],
                        iconImageOffset: [-24.5, -63],
                        iconShadow: true,
                        iconShadowImageHref: 'img/map-marker-shadow.png',
                        iconShadowImageSize: [67, 81],
                        iconShadowImageOffset: [-34.5, -68],
                    })
                    geoCollection.push(placeMark)
                }

                if (item.objects.polygons) {
                    item.objects.polygons.forEach(polygon => {

                        const myPolygon = new ymaps.Polygon([
                            polygon
                        ], {
                            // hintContent: 'polygon '+objectID
                        }, {
                            id: objectID,
                            isFavorite: isFavorite,
                            ...getStylesPolygon(isFavorite)
                        })

                        geoCollection.push(myPolygon)
                    })
                }

            })

            // рендер
            ymaps.geoQuery(geoCollection).addToMap(myMap);

            // вписать все объекты во вьюпорт
            if (myMap.geoObjects.getLength()) {
                myMap.setBounds(myMap.geoObjects.getBounds(), { useMapMargin: true })
            }

        })

        let enterID = null
        myMap.geoObjects.events
            .add('mouseenter', e => {
                if (isMobile.any()) return
                const id = e.get('target').options.get('id')
                enterID = id
                openBalloon(id)
            })
            .add('click', e => {
                if (!isLand) return
                const id = e.get('target').options.get('id')
                PubSub.publish(CHANNEL_NAMES.landShowInfo, { landID: id })
            })
        myMap.events
            .add('mouseenter', e => {
                if (!enterID || isMobile.any()) return
                myMap.balloon.close()
                enterID = null
            })

        // рендер области на карту в модалке
        PubSub.subscribe(CHANNEL_NAMES.landModalGeo.set, ({ id, map, ...data }) => {
            if (!map) return
            const geoObj = geoCollection.filter(obj => obj.geometry.getType() === 'Polygon' && obj.options.get('id') === id)

            map.geoObjects.removeAll()
            if (geoObj.length) {
                geoObj.forEach(obj => {
                    const coordinates = obj.geometry.getCoordinates()
                    const polygon = new ymaps.Polygon(coordinates,
                        {}, {
                        fillColor: '#AF846A',
                        fillOpacity: .6,
                        strokeColor: '#F4D3BA',
                        strokeWidth: 6,
                    })
                    map.geoObjects.add(polygon)
                })

                map.setBounds(map.geoObjects.getBounds(), { useMapMargin: true })
            }

        })

        function openBalloon(idMarker) {
            if (myMap.balloon.isOpen()) {
                const isOpenID = myMap.balloon.getData().geoObject.options.get('id')
                if (isOpenID === idMarker) return
            }

            const collection = ymaps.geoQuery(myMap.geoObjects);

            const result = collection
                .search(`geometry.type == 'Point'`)
                .search(`options.id == '${idMarker}'`)
                .get(0)

            result?.balloon.open()
        }
    }

    const mapContainerModal = document.querySelector('#hybrid-map-simple')

    if (mapContainerModal) {
        const wrapper = mapContainerModal.closest('.hybrid-map-container')
        const controlsContainer = createControlsContainer(wrapper)
        const controlsTop = createControlsTop(wrapper)

        const myMap = new ymaps.Map(mapContainerModal, {
            center: [55.755819, 37.617644],
            zoom: 9,
            controls: [],
            margin: [30, 30, 30, 30],
        }, {
            suppressMapOpenBlock: true,
            autoFitToViewport: 'always'
        })

        myMap.behaviors.disable('scrollZoom')
        if (isMobile.any()) {
            myMap.behaviors.disable('drag')
        }

        initZoom(myMap, controlsContainer)
        initMapType(myMap, controlsTop)

        PubSub.subscribe(CHANNEL_NAMES.landModalGeo.render, ({ id, ...data }) => {
            PubSub.publish(CHANNEL_NAMES.landModalGeo.set, { id, map: myMap })
        })
    }
}
function getStylesPolygon(isFavorite = false) {
    return {
        fillColor: !isFavorite ? '#AF846A' : '#F4D3BA',
        fillOpacity: !isFavorite ? .4 : .8,
        strokeColor: '#B9B78B',
        strokeWidth: 3,
    }
}
function getIcons(type, isFavorite = false) {
    let imgMarker = 'img/map-marker-brown.svg'
    let icBalloon = ''
    switch (type) {
        case 'agro':
            imgMarker = !isFavorite ? 'img/map-marker-land-agro.svg' : 'img/map-marker-land-agro-f.svg'
            icBalloon = 'img/ic-balloon-land-agro-white.svg'
            break
        case 'dacha':
            imgMarker = !isFavorite ? 'img/map-marker-land-dacha.svg' : 'img/map-marker-land-dacha-f.svg'
            icBalloon = 'img/ic-balloon-land-dacha-white.svg'
            break
        case 'prom':
            imgMarker = !isFavorite ? 'img/map-marker-land-prom.svg' : 'img/map-marker-land-prom-f.svg'
            icBalloon = 'img/ic-balloon-land-prom-white.svg'
            break
        case 'village':
            imgMarker = 'img/map-marker-villages.svg'
            icBalloon = 'img/ic-balloon-villages-white.svg'
            break
    }

    return { marker: imgMarker, balloon: icBalloon }
}
function initZoom(map, controlsContainer) {
    const btnIn = createButton('zoomIn')
    const btnOut = createButton('zoomOut')
    const zoomWrapper = document.createElement('DIV')
    zoomWrapper.className = 'map-zoom-wrapper'
    zoomWrapper.appendChild(btnIn)
    zoomWrapper.appendChild(btnOut)
    controlsContainer.appendChild(zoomWrapper)

    btnIn.addEventListener('click', e => {
        e.preventDefault()
        const currentZoom = map.getZoom()
        if (currentZoom === mapOptions.maxZoom) return

        map.setZoom(currentZoom + 1, { duration: mapOptions.duration })
    })

    btnOut.addEventListener('click', e => {
        e.preventDefault()
        const currentZoom = map.getZoom()
        if (currentZoom === mapOptions.minZoom) return

        map.setZoom(currentZoom - 1, { duration: mapOptions.duration })
    })
}
function initMapType(map, controlsTopContainer) {
    const btnType = createButton('typeMap')
    controlsTopContainer.appendChild(btnType)

    btnType.addEventListener('click', e => {
        e.preventDefault()

        let typeMap = null
        const typeCurrent = btnType.dataset.type

        if (typeCurrent === 'scheme') {
            btnType.textContent = 'Схема'
            btnType.dataset.type = 'hybrid'
            typeMap = mapOptions.typeHybrid
        } else {
            btnType.textContent = 'Гибрид'
            btnType.dataset.type = 'scheme'
            typeMap = mapOptions.typeScheme
        }

        map.setType(typeMap, {
            checkZoomRange: true
        }).then(() => {
            // Тип карты был установлен с допустимым уровнем масштабирования.
        }, this)
    })
}
function createControlsTop(parent) {
    const controlsContainer = createControlsContainer(parent)

    let controlsTop = parent.querySelector('.hybrid-map-controls__top')
    if (!controlsTop) {
        controlsTop = document.createElement('DIV')
        controlsTop.className = 'hybrid-map-controls__top'
        controlsContainer.appendChild(controlsTop)
    }
    return controlsTop
}
function createControlsContainer(parent) {
    let controlsContainer = parent.querySelector('.hybrid-map-controls')
    if (!controlsContainer) {
        controlsContainer = document.createElement('DIV')
        controlsContainer.className = 'hybrid-map-controls'
        parent.appendChild(controlsContainer)
    }
    return controlsContainer
}
function createButton(name) {

    const button = document.createElement('button')
    button.type = 'button'

    switch (name) {
        case 'zoomIn':
            button.className = 'btn-zoom zoom-in'
            break
        case 'zoomOut':
            button.className = 'btn-zoom zoom-out'
            break
        case 'favorite':
            button.className = 'btn btn-map-favorite-toggle'
            button.textContent = 'Показать только избранные'
            break
        case 'typeMap':
            button.className = 'btn btn-map-type-toggle'
            button.dataset.type = 'scheme'
            button.textContent = 'Гибрид'
            break
    }

    return button
}